import { Mail, Send } from "lucide-react";
import { useLang } from "../i18n";
import { Reveal } from "./Reveal";

export default function Footer() {
  const { t } = useLang();

  return (
    <footer data-testid="footer-section" className="border-t border-slate-200 bg-white">
      <div className="mx-auto max-w-6xl px-5 sm:px-8 py-16">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
            <div className="flex items-center gap-4">
              <img src="/ustp-logo.png" alt="USTP" className="h-14 w-14 rounded-2xl object-cover ring-1 ring-slate-200" />
              <div>
                <p className="font-display text-xl font-bold text-slate-900">USTP</p>
                <p className="font-mono text-[10px] tracking-[0.2em] text-slate-500">
                  UNIVERSE SCORE TOKEN PROTOCOL
                </p>
              </div>
            </div>
            <div className="text-left sm:text-right">
              <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
                {t.footer.contact}
              </p>
              <a
                href="mailto:info@ustp.it"
                data-testid="footer-mail-link"
                className="mt-1 inline-flex items-center gap-2 font-semibold text-sky-700 hover:text-sky-600"
              >
                <Mail size={16} />
                info@ustp.it
              </a>
            </div>
          </div>

          <div className="mt-10 border-t border-slate-100 pt-8">
            <p className="text-slate-600">
              {t.footer.greeting} <span className="font-semibold text-slate-900">{t.footer.team}</span>
            </p>
            <p id="disclaimer" className="mt-5 max-w-4xl text-xs leading-relaxed text-slate-400">{t.footer.disclaimer}</p>

            <nav className="mt-8 flex flex-col gap-y-3 border-t border-slate-100 pt-6" data-testid="footer-links">
              {t.footer.links.map((l) => (
                <a
                  key={l.label}
                  href={l.href}
                  target={l.external ? "_blank" : undefined}
                  rel={l.external ? "noopener noreferrer" : undefined}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-500 hover:text-sky-600 transition-colors"
                >
                  {l.href.includes("t.me") && <Send size={14} className="text-sky-500" />}
                  {l.label}
                </a>
              ))}
            </nav>
            <div className="mt-6 flex flex-wrap items-center justify-between gap-3 text-xs text-slate-400">
              <p data-testid="footer-copyright">© {new Date().getFullYear()} USTP — Universe Score Token Protocol. {t.footer.rights}</p>
              <div className="flex items-center gap-2.5">
                <img
                  src="/images/siae.jpg"
                  alt="SIAE — Società Italiana degli Autori ed Editori"
                  data-testid="footer-siae-logo"
                  className="h-9 w-9 rounded-md object-cover ring-1 ring-slate-200"
                />
                <p className="font-mono">N. 22562423 · 04/04/2025</p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </footer>
  );
}
